module.exports = __webpack_public_path__ + "static/media/8.df5508c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/8.jpg
// module id = 213
// module chunks = 0